import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesOcorrencias.vue?vue&type=template&id=427e1926"
import script from "./LicitacaoAtualizacaoAcoesOcorrencias.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesOcorrencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports